<template>
  <div class="test-creation">
    <header class="back-header">
      <div class="back-left" @click="goBack">
        <img src="@/assets/images/free-practice/arrow_back.png" class="back-img" />
        <span class="back-text">{{ $t('mark_back') }}</span>
      </div>
      <div class="header-right" @click="closeDialog">
        <img src="@/assets/images/free-practice/bc-close.png" class="close-img" />
      </div>
    </header>

    <section class="content-con">
      <section class="content-left">
        <div class="page-title">{{ $t(cardTitle) }}</div>
        <!---------------------- 顶部范围筛选 开始---------------------->
        <div class="select-con">
          <el-select v-model="levelId" @change="changeLevel" size="small" class="select">
            <el-option
              v-for="item in selectLevelList"
              :key="item.id"
              :label="item.transName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select v-model="is_peg" @change="getNewTypeVocabulary" size="small" class="select">
            <el-option
              v-for="item in markSelectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!---------------------- 顶部范围筛选 结束---------------------->
        <p class="section-title">
          {{ typeOfPractice == 'FLASHCARDS' ? $t('generate_flashcards') : $t('generate_practice') }}
        </p>
        <!---------------------- 左侧随机选词 ---------------------->
        <div class="random-con" :class="{ 'active-title-type': getWordsType == 'random' }">
          <md-checkbox
            class="md-checkbox"
            v-model="getWordsType"
            value="random"
            @change="changeType('random')"
            >{{ $t('random_select') }}</md-checkbox
          >
          <el-select
            v-model="randomCounts"
            size="small"
            style="width: 90px; margin: 0 12px"
            :class="{ disabledContent: getWordsType != 'random' }"
            :disabled="getWordsType != 'random'"
          >
            <el-option v-for="item in randomList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <!-- <span :class="{ disabledContent: getWordsType != 'random' }">{{
            $t('free_practice_words_quantifier')
          }}</span> -->
        </div>
        <!---------------------- 左侧手动选词 ---------------------->
        <div class="manual-con">
          <div class="title-con">
            <md-checkbox
              class="md-checkbox"
              v-model="getWordsType"
              value="manual"
              @change="changeType('manual')"
              >{{ $t('manual_select') }}</md-checkbox
            >
            <span class="light-hint">({{ $t('max_words', { number: 30 }) }})</span>
            <p class="manual-choosed" v-if="getWordsType == 'manual'">
              {{ $t('already_choose', { total: allmanualCounts }) }}
            </p>
          </div>

          <div
            :class="{ disabledContent: getWordsType != 'manual' }"
            class="table-con"
            @click="clickTable"
          >
            <div class="disabled-table-wrap" v-if="getWordsType == 'random'"></div>
            <el-table
              ref="vocabularyRef"
              @selection-change="handleSelectionChange"
              @select-all="handleSelectAll"
              :data="tableData"
              :highlight-selection-row="true"
              row-key="id"
              header-row-class-name="table-header"
              row-class-name="row-class"
              cell-class-name="cell-class"
              height="240px"
            >
              <el-table-column type="selection" width="50" :selectable="checkedSelectable">
              </el-table-column>
              <el-table-column :label="$t('vocabulary')" width="120" prop="word">
                <template slot-scope="scope">
                  <span class="vocab-word">{{ scope.row.word }}</span></template
                ></el-table-column
              >
              <el-table-column :label="$t('vocab_pinyin')" width="216">
                <template slot="header">
                  <span style="margin-left: 24px">{{ $t('vocab_pinyin') }}</span>
                </template>
                <template slot-scope="scope">
                  <md-button class="md-icon-button" @click="handlePlay(scope.row)">
                    <img src="@/assets/images/free-practice/yellow_horn.png" class="horn-icon" />
                  </md-button>

                  <span class="pinyin">{{ scope.row.pinyin_tone }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('vocab_translate')"
                width="290"
                prop="translation"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-pagination
              :small="true"
              background
              @current-change="handleCurrentChange"
              :current-page.sync="page_num"
              :page-size="page_size"
              layout="total, prev, pager, next"
              :total="tableTotalCount"
              class="class-pagination"
              v-if="tableTotalCount > 0"
            >
            </el-pagination>
          </div>
        </div>
      </section>
      <section class="content-right">
        <div class="content-right-main">
          <div class="right-item-con">
            <div class="right-top-con">
              <p class="section-title title">{{ $t('free_practice_question') }}</p>
              <p class="section-title title">{{ $t('mark_answer') }}</p>
            </div>
            <div class="right-top-con">
              <div>
                <md-radio
                  :disabled="answerKey == item.key"
                  v-for="item in contentList"
                  :key="'q' + item.key"
                  class="md-radio"
                  v-model="questionKey"
                  :value="item.key"
                  >{{ $t(item.title) }}</md-radio
                >
              </div>
              <div>
                <md-radio
                  :disabled="questionKey == item.key"
                  v-for="item in contentList"
                  :key="'a' + item.key"
                  class="md-radio"
                  v-model="answerKey"
                  :value="item.key"
                  >{{ $t(item.title) }}</md-radio
                >
              </div>
            </div>

            <!-- </div> -->
          </div>
          <div v-if="typeOfPractice == 'EXERCISE'" class="right-item-con right-bottom-con">
            <p class="section-title title">{{ $t('free_practice_choose_exercise') }}</p>
            <md-radio
              v-model="exerciseTypeKey"
              value="Choice"
              :style="{ width: exerciseRaiodWidth }"
              >{{ $t('free_practice_exercise_select') }}</md-radio
            >
            <md-radio
              v-model="exerciseTypeKey"
              value="Pairs"
              :style="{ width: exerciseRaiodWidth }"
              :disabled="pairsDisabled"
              >{{ $t('free_practice_exercise_Pairs') }}</md-radio
            >
            <md-radio
              v-model="exerciseTypeKey"
              value="Judge"
              :style="{ width: exerciseRaiodWidth }"
              >{{ $t('free_practice_exercise_TF') }}</md-radio
            >
          </div>
        </div>
        <div class="button-con">
          <div
            class="fp-button fp-submit-btn"
            @click="launchPractice"
            :disabled="submitLoading || launchsWordDisabled || launchQuestionTypeDisabled"
          >
            <span v-if="submitLoading"> <i class="el-icon-loading"></i>{{ $t('loading') }}</span>
            <span v-else>{{ $t('launch') }}</span>
          </div>
          <div class="fp-button fp-cancel-btn" @click="goBack">{{ $t('change_lang_cancel') }}</div>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { transferLanguage } from '@/utils/utils'
import { hideVocabulary } from '@/utils/hskTool'
import { apiRequest } from '@/serves/http'
import ApiPath from '@/serves/path'
export default {
  props: {
    cardTitle: {
      type: String,
      default: 'flashcards_title',
    },
    typeOfPractice: {
      // FLASHCARDS | EXERCISE
      type: String,
      default: 'FLASHCARDS',
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      markSelectList: [
        { label: this.$t('vocab_all_marked'), value: null },
        { label: this.$t('vocab_already_marked'), value: 1 },
        { label: this.$t('vocab_unmarked'), value: 0 },
      ],
      contentList: [
        {
          title: 'vocab_translate',
          key: 'Meaning',
        },
        {
          title: 'free_practice_sound',
          key: 'Sound',
        },
        {
          title: 'free_practice_characters',
          key: 'Characters',
        },
        {
          title: 'vocab_pinyin',
          key: 'Pinyin',
        },
      ],
      questionKey: '',
      answerKey: '',
      exerciseTypeKey: '',
      randomList: [],
      randomCounts: 0,
      manualMaxCount: 30,
      savedManualSelectionList: [], // 非当前页的选中值
      savedManualSelectIds: [], // 非当前页的选中值的id
      manualSelectionList: [], // 当前页手动选择词汇列表
      getWordsType: 'random', // random|manual
      levelId: 1, // 词汇范围筛选-level
      levelName: 'HSK1', // 选中的词汇
      tableData: [], // 词汇表格数据
      page_num: 1, // 词汇表格分页
      page_size: 10, // 词汇表格分页
      is_peg: null, // 词汇表格标星''|0|1
      tableTotalCount: 0,
      outerLevelId: '',
    }
  },

  computed: {
    ...mapState({
      levelList: (state) => state.level.levelList,
    }),
    exerciseRaiodWidth() {
      let width = '48%'
      let local = localStorage.getItem('language')
      if (local == 'vi' || local == 'fr' || local == 'mn') {
        width = '90%'
      }
      return width
    },
    pairsDisabled() {
      if (this.getWordsType == 'manual' && this.allmanualCounts > 2) {
        return false
      } else if (this.getWordsType == 'random' && this.tableTotalCount > 2) {
        return false
      }
      return true
    },
    launchsWordDisabled() {
      if (this.tableTotalCount > 0 && this.getWordsType == 'random') {
        return false
      } else if (this.getWordsType == 'manual' && this.allmanualCounts > 0) {
        return false
      }
      return true
    },
    launchQuestionTypeDisabled() {
      if (this.typeOfPractice == 'FLASHCARDS') {
        if (this.questionKey && this.answerKey) {
          return false
        }
      } else {
        if (this.questionKey && this.answerKey && this.exerciseTypeKey) {
          return false
        }
      }
      return true
    },
    selectLevelList() {
      let temp = []
      this.levelList.forEach((item) => {
        item?.levels.forEach((level) => {
          level.type_name = item.type_name
          // hskk有多语言，目前无hskk类型，依然做保留
          level.transName = item.type_name + transferLanguage(level.app_level_name)
          let levelTypeName = level.type_name.toLowerCase() + level.level_id
          if (hideVocabulary.indexOf(levelTypeName) < 0) {
            temp.push(level)
          }
        })
      })
      return temp
    },
    // 手动选择的单词列表
    allManualSelectionList() {
      return [...this.manualSelectionList, ...this.savedManualSelectionList]
    },
    // 手动选择的单词个数
    allmanualCounts() {
      return this.allManualSelectionList.length
    },
  },
  methods: {
    // -----------------------------获取表格词汇-----------------------------
    // 获取等级词汇数据
    getWordsList() {
      const params = {
        level_ids: [this.levelId],
        is_peg: this.is_peg,
        page_num: this.page_num,
        page_size: this.page_size,
      }
      if (this.is_peg === null) {
        delete params.is_peg
      }
      apiRequest.post(ApiPath.get_vocab_detail, params, { loading: true }).then((res) => {
        this.tableTotalCount = res.data.total_count
        this.randomList = []
        let tempRandomList = [10, 20, 30]
        tempRandomList.forEach((randomNumber) => {
          if (this.tableTotalCount >= randomNumber) {
            this.randomList.push(randomNumber)
          }
        })
        if (this.randomList.length < tempRandomList.length) {
          this.randomList.push(this.tableTotalCount)
        }
        this.randomCounts = this.randomList[0]

        if (res.data.list) {
          this.tableData = this.formatArr(res.data.list)
          if (this.savedManualSelectIds.length > 0) {
            this.getSelectChecked(this.tableData)
          }
        } else {
          this.tableData = []
          this.$message.error(this.$t('none_mark_words_hint'))
        }
      })
    },
    formatArr(arr) {
      return arr.map((item) => {
        if (item.levels) {
          item.levels = item.levels.reduce((acc, item) => {
            // 检查是否已经有当前type_name的项
            const existing = acc.find((x) => x.type_name === item.type_name)
            // 如果不存在，或存在但当前项的level_type更小，则更新/添加到累加器中
            if (!existing || item.level_type < existing.level_type) {
              // 移除已有的项（如果存在且当前项的level_type更小）
              const filteredAcc = existing ? acc.filter((x) => x.type_name !== item.type_name) : acc
              // 添加/更新项
              return [...filteredAcc, item]
            }
            return acc
          }, [])
        }
        return { ...item, isPinyinPlay: false }
      })
    },
    // levelId 变化，重新请求列表
    changeLevel(val) {
      const obj = this.selectLevelList.find((item) => item.id == val)
      if (obj) {
        this.levelName = obj.level_name
      }
      this.getNewTypeVocabulary()
    },
    //is_peg变化，重新请求列表
    getNewTypeVocabulary() {
      this.savedManualSelectionList = []
      this.getWordsList()
    },
    // 分页
    handleCurrentChange(val) {
      this.page_num = val
      this.handleSaveManualSelection()
      this.getWordsList()
    },
    changeType(e) {
      this.getWordsType = e
    },
    // -----------------------------表格CheckBox相关-----------------------------
    // 表格是否可点击checkbox
    checkedSelectable(row) {
      const allowIds = this.allManualSelectionList.map((e) => e.id)
      if (this.allmanualCounts >= this.manualMaxCount) {
        return allowIds.includes(row.id)
      }
      return true
    },
    // 随机选择时，禁止点击表格
    clickTable() {
      if (this.getWordsType == 'random') {
        console.log('false')
        return false
      }
    },
    // checkbox数据变化
    handleSelectionChange(val) {
      this.manualSelectionList = val
    },
    // checkbox全选
    handleSelectAll(selection) {
      let tableRef = this.$refs.vocabularyRef
      let selectionAll = selection.length > 0 ? true : false
      if (!selectionAll) {
        return
      }
      let savedLength = this.savedManualSelectIds.length
      console.log(savedLength, 'savedLength')
      let presentLength = selection.length
      console.log(presentLength, 'presentLength')
      if (savedLength + presentLength > this.manualMaxCount) {
        this.$message.error(this.$t('excceed_max_count', { total: this.manualMaxCount }))
        tableRef.clearSelection()
        let extraCount = this.manualMaxCount - savedLength
        console.log(extraCount, 'extraCount')
        this.$nextTick(() => {
          for (let i = 0; i < extraCount; i++) {
            this.$refs.vocabularyRef.toggleRowSelection(this.tableData[i], true)
          }
        })
      }
    },
    // 分页前，将checkbox选中数据存储
    handleSaveManualSelection() {
      this.savedManualSelectionList = [
        ...this.savedManualSelectionList,
        ...this.manualSelectionList,
      ]
      this.savedManualSelectIds = this.savedManualSelectionList.map((e) => e.id)
      this.manualSelectionList = []
    },
    // 分页后，将曾经选中数据从save列表取出；
    getSelectChecked() {
      let deleteArrIndexArr = []
      this.$nextTick(() => {
        this.tableData.forEach((item) => {
          let delIndex = this.savedManualSelectIds.indexOf(item.id)
          if (delIndex > -1) {
            deleteArrIndexArr.push(delIndex)
            this.$refs.vocabularyRef.toggleRowSelection(item, true)
          }
        })
        if (deleteArrIndexArr.length > 0) {
          for (let i = deleteArrIndexArr.length; i--; i > -1) {
            this.savedManualSelectionList.splice(deleteArrIndexArr[i], 1)
            this.savedManualSelectIds.splice(deleteArrIndexArr[i], 1)
          }
        }
      })
    },
    // -----------------------------组合题目-----------------------------
    launchPractice() {
      if (this.submitLoading || this.launchsWordDisabled || this.launchQuestionTypeDisabled) {
        return
      }
      let params = {
        isRandom: this.getWordsType == 'random' ? true : false,
        randomCounts: this.randomCounts,
        allManualSelectionList: this.allManualSelectionList,
        levelName: this.levelName,
        levelId: this.levelId,
        is_peg: this.is_peg,
        questionKey: this.questionKey,
        answerKey: this.answerKey,
        exerciseTypeKey: this.exerciseTypeKey,
      }

      this.$emit('launchPractice', params)
    },
    // -----------------------------获取表格词汇-----------------------------

    // 其他-----------------------------
    //播放拼音音频
    handlePlay(row) {
      var soundUrl = row.tts_url || ''
      if (soundUrl) {
        if (row.isPinyinPlay) {
          this.$player.pause()
        } else {
          //第五个参数表示是否加时间戳，tts地址的音频由于后端限制，不能添加时间戳，否则不能正常播放
          //最后一个参数是是否判断为同一个音频，词汇处不需要
          this.$player.play(soundUrl, '', {}, false, false, false)
          row.isPinyinPlay = true
          console.log(this.$player)
        }

        this.$player.onpaused = () => {
          console.log('暂停了')
          row.isPinyinPlay = false
        }
        this.$player.onended = () => {
          row.isPinyinPlay = false
          console.log('自动结束')
        }
        this.$player.onUnload = () => {
          console.log('unloaded')
          row.isPinyinPlay = false
        }
        this.$player.onloaderrored = () => {
          row.isPinyinPlay = false
        }
      }
    },
    goBack() {
      this.$emit('goBack')
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
  },
  mounted() {
    let queryLevel = this.$route.query.level

    let levelObj = null
    for (let i = 0; i < this.levelList.length; i++) {
      let temp = this.levelList[i].levels.find((item) => {
        let levelName = (item.type_name + item.level_id).toLowerCase()
        return queryLevel == levelName
      })
      if (temp) {
        levelObj = temp
        break
      }
    }
    console.log(levelObj)
    this.levelId = levelObj.id
    this.changeLevel(this.levelId)

    this.getWordsList()
    if (this.typeOfPractice == 'FLASHCARDS') {
      this.contentList.splice(3, 1)
    }
  },
}
</script>
<style lang="scss">
.table-header {
  color: #b5b5be;
  font-size: 12px;
  font-weight: bold;
  .el-table__cell {
    background: #fafafb !important;
  }
}
.row-class {
  color: #2c2f46;
  font-size: 16px;
  td {
    border: none;
  }
}
.cell-class {
  border: none;
}
</style>
<style lang="scss" scoped>
@import './styles/testCreation.scss';
</style>
